import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import ApplicationDetailPage from "../../../components/Application/ApplicationDetail/index";

const ApplicationDetail = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          <ApplicationDetailPage {...props} />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ApplicationDetail;
